export var AssociationStatus;
(function (AssociationStatus) {
    AssociationStatus["Pending"] = "pending";
    AssociationStatus["Editing"] = "editing";
    AssociationStatus["ApprovalPending"] = "approval-pending";
    AssociationStatus["Approved"] = "approved";
    AssociationStatus["LastYear"] = "last-year";
    AssociationStatus["Inactive"] = "inactive";
})(AssociationStatus || (AssociationStatus = {}));
;
//# sourceMappingURL=association-status.enum.js.map